//this model only works with Foundry
var PollResults = Chaplin.Model.extend({
    initialize: function(attrs, options) {
        _.bindAll(this, 'pollResultsLoaded', 'pollResultsLoadFailed', 'pollResultsLoadLocal');
    },

    fileName: function() {
        return '/local-data/poll_results/' + this.get('slug') + '.json';
    },

    url: function() {
        return `${this.get('response_set').endpoint}/response_sets/${this.get('response_set').id}/poll_results`;
    },

    loadPollResults: function(options) {
        this.options = options || {};
        if(EF.options.local) {
            return this.pollResultsLoadLocal();
        } else {
            let onFail = this.options.failToLocal ? this.pollResultsLoadLocal : this.pollResultsLoadFailed;
            return this.fetch(this.options)
                .done(this.pollResultsLoaded)
                .fail(onFail);
        }
    },

    pollResultsLoadLocal: function() {
        var localData;
        var deferred = $.Deferred();
        deferred.done(this.pollResultsLoaded);
        deferred.fail(this.pollResultsLoadFailed);
        try {
            localData = require(this.fileName());
            this.set('local', true);
            deferred.resolve(localData);
        } catch(e) {
            deferred.reject();
        }
        return deferred;
    },

    pollResultsLoaded: function(pollResult) {
        //mini-require js cache de file response and second load doesn't work.
        let results = pollResult.data && pollResult.data.attributes ? pollResult.data.attributes.results : {};
        var pollResultsCopy = this.get('local') ?  $.extend(true, {}, results) : results;
        this.set('sections', new EF.Collections.SectionsCollection(pollResultsCopy.sections));

        this.trigger('poll_results:load', this);
        EF.trigger('poll_results:load', this);
    },

    pollResultsLoadFailed: function() {
        this.trigger('poll_results:load:failure');
        EF.trigger('poll_results:load:failure');
    },

    filterQuestionsBySection: function(sectionIndex) {
        var section = this.get('sections').at(sectionIndex);
        section.set('questions', new EF.Collections.Assessments.QuestionsCollection(section.get('questions')));

        this.set('sections', new EF.Collections.SectionsCollection(section));
    },

    filterQuestionsBySectionAndQuestion: function(sectionIndex, questionIndex) {
        var section = this.get('sections').at(sectionIndex);
        section.set('questions', new EF.Collections.Assessments.QuestionsCollection(section.get('questions')[questionIndex]));

        this.set('sections', new EF.Collections.SectionsCollection(section));
    }
});

_.extend(EF.Models, {
  PollResults: PollResults
});
